export const buildNotificationHref = ({ action, itemId, module, message }) => {
  const href = typeof action === 'string' ? action.trim() : '';
  if (!href.startsWith('/')) return href.includes('/quy-trinh/') ? href : null;
  if (module?.toLowerCase() !== 'quytrinh' || !itemId || !href.startsWith('/quy-trinh/task-inbox')) return href;

  const key = /^\s*Đã bắt đầu quy trình:/i.test(String(message).replace(/<[^>]*>/g, ''))
    ? 'instanceId'
    : 'taskId';
  return `${href}${href.includes('?') ? '&' : '?'}${key}=${encodeURIComponent(itemId)}`;
};

export const isDuanNotification = ({ module, action } = {}) => {
  const moduleName = String(module ?? '').toLowerCase();
  const actionStr = String(action ?? '').toLowerCase();
  return moduleName === 'duan'
    || actionStr.includes('/du-an')
    || actionStr.includes('/action-plan-v2');
};

export const buildDuanNotificationHref = ({ action, itemId }) => {
  const href = typeof action === 'string' ? action.trim() : '';
  if (href.includes('/action-plan-v2')) {
    return href.startsWith('/') ? href : `/${href.replace(/^\/+/, '')}`;
  }
  if (href.includes('/du-an') || !href) {
    if (!itemId) return href || '/du-an';
    return `/du-an?openCongViec=${encodeURIComponent(itemId)}`;
  }
  return href.startsWith('/') ? href : null;
};

export const isNotificationRead = (notification) => {
  const value = notification?.read ?? notification?.Read ?? notification?.isRead ?? notification?.IsRead;
  return value === true || value === 1 || value === '1' || value === 'true';
};

export const countUnreadNotifications = (notifications) => notifications.filter((item) => !isNotificationRead(item)).length;

export const markAllNotificationsRead = (notifications) => notifications.map((item) => ({ ...item, isRead: true }));

export const isProcessNotification = (notification) => {
  const module = String(
    notification?.module ?? notification?.Module ?? notification?.phanHe ?? notification?.PhanHe ?? notification?.data?.module ?? notification?.Data?.module ?? '',
  ).toLowerCase();
  const action = String(notification?.actionUrl ?? notification?.ActionUrl ?? notification?.action ?? notification?.Action ?? '').toLowerCase();
  const message = String(notification?.content ?? notification?.Content ?? notification?.message ?? notification?.Message ?? '').replace(/<[^>]*>/g, '');

  return module === 'quytrinh' || module === 'quy-trinh' || action.includes('/quy-trinh/') || /^\s*Đã bắt đầu quy trình:/i.test(message);
};

export const sortNotificationsNewestFirst = (notifications) => [...notifications].sort((left, right) => {
  const leftTime = Date.parse(left?.date ?? left?.Date ?? left?.timestamp ?? left?.Timestamp ?? '') || 0;
  const rightTime = Date.parse(right?.date ?? right?.Date ?? right?.timestamp ?? right?.Timestamp ?? '') || 0;
  return rightTime - leftTime;
});
